import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { AplicativosPage } from "./components/pages/aplicativos/AplicativosPage";
import { HomePage } from "./components/pages/home/HomePage";
import { OperadorasPage } from "./components/pages/operadoras/OperadorasPage";
import { PlanosPage } from "./components/pages/planos/PlanosPage";
import {
  APLICATIVOS_URL,
  HOME_URL,
  OPERADORAS_URL,
  PLANOS_URL,
} from "./constants/router";
import useGoogleAnalyticsHook from "./utils/analytics/hooks/useGoogleAnalyticsHook";

export const Router = () => {
  useGoogleAnalyticsHook();
  return (
    <Switch>
      <Route
        exact={true}
        path={OPERADORAS_URL}
        component={OperadorasPage}
      ></Route>
      <Route
        exact={true}
        path={APLICATIVOS_URL}
        component={AplicativosPage}
      ></Route>
      <Route exact={true} path={PLANOS_URL} component={PlanosPage}></Route>
      <Route exact={true} path={HOME_URL} component={HomePage}></Route>
      <Redirect to={HOME_URL} />
    </Switch>
  );
};
